import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar       from './components/layout/Navbar';
import Footer       from './components/layout/Footer';
import HomePage     from './pages/HomePage';
import BooksPage    from './pages/BooksPage';
import MeteorShower from './components/common/MeteorShower';
import './styles/globals.css';

export default function App() {
  return (
    <BrowserRouter>
      <div style={{ position: 'relative', minHeight: '100vh' }}>
        <MeteorShower />
        <div style={{ position: 'relative', zIndex: 1 }}>
          <Navbar />
          <Routes>
            <Route path="/"      element={<HomePage />} />
            <Route path="/books" element={<BooksPage />} />
          </Routes>
          <Footer />
        </div>
      </div>
    </BrowserRouter>
  );
}
